export default __webpack_public_path__ + "static/media/3.2f476622.svg";